import {
  MBox,
  MCheckbox,
  MFlex,
  MText,
} from '../../../../../components/Monetize';
import { PRODUCT_TYPE_DISPLAY } from '../../../../../constants/products';
import {
  areAllBulkProductsOptional,
  BulkOfferingProducts,
  getSelectedBulkProductIds,
  isBulkProductLocked,
  toggleBulkProductId,
} from './utils/bulkOfferingUtils';

interface BulkOfferingProductsChecklistProps {
  id: string;
  offeringProducts: BulkOfferingProducts;
  productIds?: string[];
  isDisabled?: boolean;
  onChange: (productIds: string[]) => void;
}

/**
 * Inline product chooser for one offering in the bulk review step, mirroring
 * the single-add Manage Products modal. Required products are locked on.
 */
export const BulkOfferingProductsChecklist = ({
  id,
  offeringProducts,
  productIds,
  isDisabled,
  onChange,
}: BulkOfferingProductsChecklistProps) => {
  const selectedIds = getSelectedBulkProductIds(offeringProducts, productIds);

  return (
    <MBox id={id} bg="bg.subtle" borderRadius="md" px={4} py={3}>
      {areAllBulkProductsOptional(offeringProducts) && (
        <MText fontSize="xs" color="fg.muted" mb={1}>
          All products in this offering are optional. The first is included
          unless you choose.
        </MText>
      )}
      <MFlex direction="column">
        {offeringProducts.map((offeringProduct) => {
          const { product } = offeringProduct;
          return (
            <MCheckbox
              key={product.id}
              py={1}
              isChecked={selectedIds.has(product.id)}
              isDisabled={
                isDisabled || isBulkProductLocked(offeringProduct, selectedIds)
              }
              onChange={(event) =>
                onChange(
                  toggleBulkProductId(
                    offeringProducts,
                    productIds,
                    product.id,
                    event.target.checked,
                  ),
                )
              }
            >
              <MText ml={1}>
                <MBox as="span" fontWeight="bold">
                  {product.name}
                </MBox>
                {product.productType &&
                  ` (${PRODUCT_TYPE_DISPLAY[product.productType]})`}
              </MText>
            </MCheckbox>
          );
        })}
      </MFlex>
    </MBox>
  );
};
